var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHobbiesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(-72 -3032)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(72 3032)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(83.729 3042.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4710",
    "data-name": "Path 4710",
    d: "M-259.477,252.492v.328c0,2.291,0,4.583-.008,6.874a.731.731,0,0,1-.186.462c-.787.81-1.589,1.607-2.394,2.4a.56.56,0,0,1-.347.16c-1.584.01-3.168.007-4.752.006-.049,0-.1-.008-.175-.015a2.053,2.053,0,0,0-.419-2.52,2.127,2.127,0,0,0,.675-1.527,2.1,2.1,0,0,0-.682-1.512,2.1,2.1,0,0,0,.682-1.516,2.039,2.039,0,0,0-.679-1.517l.415-.514a4.094,4.094,0,0,0,3.768,2.531v-.983c-.259-.041-.519-.064-.77-.126a3.027,3.027,0,0,1-2.008-1.7,6.7,6.7,0,0,1-.721-3.015c-.007-1.816,0-3.633,0-5.449,0-.765.143-.956.868-1.18.171-.053.342-.106.513-.157.42-.124.562-.039.636.383.109.622.21,1.246.323,1.867.23,1.264.461,2.527.7,3.788a.846.846,0,0,0,.216.405q.928.954,1.882,1.881a.95.95,0,0,0,.433.228C-260.848,252.222-260.186,252.348-259.477,252.492Z",
    transform: "translate(283.813 -234.329)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    d: "M-396.939,373.293c-.982,0-1.965,0-2.947,0a1.021,1.021,0,0,1-1.091-1.021,1.016,1.016,0,0,1,1.076-1q2.979,0,5.958,0a1.018,1.018,0,0,1,1.076,1,1.021,1.021,0,0,1-1.093,1.02C-394.953,373.294-395.946,373.293-396.939,373.293Z",
    transform: "translate(408.583 -354.027)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4712",
    "data-name": "Path 4712",
    d: "M-120.652,387.525h1.99v7.056h-1.99Z",
    transform: "translate(146.025 -369.256)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M-381.415,419.27c.813,0,1.627,0,2.44,0a1.021,1.021,0,0,1,1.094,1.018,1.024,1.024,0,0,1-1.107,1.006q-2.44,0-4.88,0a1.024,1.024,0,0,1-1.109-1,1.023,1.023,0,0,1,1.122-1.021Q-382.635,419.268-381.415,419.27Z",
    transform: "translate(393.596 -398.988)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M-514.886,270.346a.487.487,0,0,1-.488.486,2.061,2.061,0,0,0-2.053,2.058.485.485,0,0,1-.491.482.488.488,0,0,1-.51-.5,2.054,2.054,0,0,0-2.034-2.043.491.491,0,0,1-.505-.5.49.49,0,0,1,.5-.5,2.055,2.055,0,0,0,2.036-2.041.488.488,0,0,1,.508-.5.508.508,0,0,1,.5.511,2.022,2.022,0,0,0,2.013,2.023A.509.509,0,0,1-514.886,270.346Zm-3.048.7.734-.714-.7-.707-.765.683Z",
    transform: "translate(520.966 -256.643)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M-261.939,99.29a.487.487,0,0,1,.511.495,2.057,2.057,0,0,0,2.033,2.043.491.491,0,0,1,.506.5.49.49,0,0,1-.5.5,2.056,2.056,0,0,0-2.036,2.04.489.489,0,0,1-.508.5.509.509,0,0,1-.5-.511,2.018,2.018,0,0,0-2.013-2.023.509.509,0,0,1-.522-.52.509.509,0,0,1,.518-.491,2.021,2.021,0,0,0,2.016-2.021A.508.508,0,0,1-261.939,99.29Zm.729,3.036-.709-.72-.726.691.688.762Z",
    transform: "translate(281.196 -99.29)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    "data-name": "Path 4716",
    d: "M-390.053,133.568c.778-.775,1.543-1.557,2.334-2.313a.716.716,0,0,1,1.089.1,1.409,1.409,0,0,1,.126,1.775c-.287.427-.287.495,0,.925a1.407,1.407,0,0,1-.128,1.775.692.692,0,0,1-1.061.107C-388.49,135.176-389.252,134.377-390.053,133.568Z",
    transform: "translate(398.351 -129.035)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    "data-name": "Path 4717",
    d: "M-439.2,103.769c-.79-.792-1.563-1.553-2.318-2.332a.724.724,0,0,1,.074-1.09,1.444,1.444,0,0,1,1.8-.133c.424.292.479.292.9.005a1.429,1.429,0,0,1,1.824.15.712.712,0,0,1,.049,1.069C-437.626,102.218-438.4,102.974-439.2,103.769Z",
    transform: "translate(446.757 -99.916)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    "data-name": "Path 4718",
    d: "M-438.852,182.169c.838.832,1.609,1.583,2.36,2.353a.7.7,0,0,1-.03,1.066,1.425,1.425,0,0,1-1.8.187c-.484-.318-.484-.318-.947-.011a1.433,1.433,0,0,1-1.757-.116.743.743,0,0,1-.09-1.14C-440.373,183.726-439.617,182.959-438.852,182.169Z",
    transform: "translate(446.386 -176.916)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    d: "M-469.164,133.873c-.79.786-1.539,1.542-2.3,2.285a.729.729,0,0,1-1.117-.025,1.408,1.408,0,0,1-.139-1.822c.264-.378.264-.489,0-.871a1.413,1.413,0,0,1,.18-1.868.68.68,0,0,1,1.038-.017C-470.723,132.31-469.96,133.082-469.164,133.873Z",
    transform: "translate(476.032 -129.292)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    d: "M-365.938,469.281c-.655,0-1.31,0-1.965,0a1.02,1.02,0,0,1-1.076-1.005,1.013,1.013,0,0,1,1.06-1.019q1.981-.005,3.961,0a1.015,1.015,0,0,1,1.06,1.02,1.02,1.02,0,0,1-1.076,1C-364.628,469.283-365.283,469.281-365.938,469.281Z",
    transform: "translate(378.612 -443.931)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    d: "M-353.493,221.949H-354.5c-.068-3.3-.834-6.33-3.325-8.721.087-.123.182-.26.28-.4s.184-.253.313-.429C-354.421,214.99-353.57,218.294-353.493,221.949Z",
    transform: "translate(368.169 -205.234)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    d: "M-350.431,515.254c.5,0,.993,0,1.489,0a1.015,1.015,0,0,1,1.031,1.017,1.014,1.014,0,0,1-1.043,1.006q-1.489.008-2.979,0a1.014,1.014,0,0,1-1.046-1,1.015,1.015,0,0,1,1.058-1.021C-351.424,515.251-350.928,515.254-350.431,515.254Z",
    transform: "translate(363.626 -488.887)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    d: "M-287.743,107.664v.968h-.984v-.968Z",
    transform: "translate(303.447 -107.133)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    d: "M-288.717,203.5h.973v.978h-.973Z",
    transform: "translate(303.438 -196.892)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    d: "M-519.718,235.515v.976h-.982v-.976Z",
    transform: "translate(520.717 -226.881)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4726",
    "data-name": "Path 4726",
    d: "M-399.757,283.65v.97h-.984v-.97Z",
    transform: "translate(408.361 -271.965)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4727",
    "data-name": "Path 4727",
    d: "M-352.744,315.472h.976v.982h-.976Z",
    transform: "translate(363.406 -301.77)",
    fill: "#febaba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbiesicon);
export default __webpack_public_path__ + "static/media/hobbiesicon.08654f591817b598672349cdd85b0d58.svg";
export { ForwardRef as ReactComponent };